import React, { useEffect } from 'react';
import { EventBus } from '@vtblife/event-bus';
import { OpenQuizModal } from './custom-logic/open-quiz-modal/open-quiz-modal';
export * from './components/quiz-modal/quiz-modal';
export { Quiz } from './components/quiz/quiz';
export * from './custom-logic/quiz-modals/quiz-modals';
export * from './custom-logic/open-quiz-modal/open-quiz-modal';
export * from './utils/quiz.service';
export const AllQuizModals = () => {
    useUserInit();
    return React.createElement(OpenQuizModal, null);
};
const eventBus = EventBus.getInstance();
function useUserInit() {
    useEffect(() => {
        eventBus.publish({
            type: 'app:contextChanged',
            category: 'behavior',
            data: {
                authInfo: {
                    user: { email: 'user@m2.ru' },
                },
            },
        });
    }, []);
}
//# sourceMappingURL=index.js.map